<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    
    <div class="row">
      <div class="col-xl-3 col-md-6">
        <div class="card mini-stats-wid">
          <div class="card-body">
            <div class="d-flex">
              <div class="flex-grow-1">
                <p class="text-muted fw-medium">Total de Usuários</p>
                <h4 class="mb-0">{{ stats.total_users || 0 }}</h4>
              </div>
              <div class="flex-shrink-0 align-self-center">
                <div class="mini-stat-icon avatar-sm rounded-circle bg-primary">
                  <span class="avatar-title">
                    <i class="bx bx-user font-size-24"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-xl-3 col-md-6">
        <div class="card mini-stats-wid">
          <div class="card-body">
            <div class="d-flex">
              <div class="flex-grow-1">
                <p class="text-muted fw-medium">Total de Pacientes</p>
                <h4 class="mb-0">{{ stats.total_patients || 0 }}</h4>
              </div>
              <div class="flex-shrink-0 align-self-center">
                <div class="mini-stat-icon avatar-sm rounded-circle bg-success">
                  <span class="avatar-title">
                    <i class="bx bx-group font-size-24"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-xl-3 col-md-6">
        <div class="card mini-stats-wid">
          <div class="card-body">
            <div class="d-flex">
              <div class="flex-grow-1">
                <p class="text-muted fw-medium">Total de Exames</p>
                <h4 class="mb-0">{{ stats.total_exams || 0 }}</h4>
              </div>
              <div class="flex-shrink-0 align-self-center">
                <div class="mini-stat-icon avatar-sm rounded-circle bg-info">
                  <span class="avatar-title">
                    <i class="bx bx-file font-size-24"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-xl-3 col-md-6">
        <div class="card mini-stats-wid">
          <div class="card-body">
            <div class="d-flex">
              <div class="flex-grow-1">
                <p class="text-muted fw-medium">Usuários Ativos</p>
                <h4 class="mb-0">{{ stats.active_users || 0 }}</h4>
              </div>
              <div class="flex-shrink-0 align-self-center">
                <div class="mini-stat-icon avatar-sm rounded-circle bg-warning">
                  <span class="avatar-title">
                    <i class="bx bx-check-circle font-size-24"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Status do Sistema</h4>
            <div class="table-responsive">
              <table class="table table-nowrap mb-0">
                <thead class="table-light">
                  <tr>
                    <th scope="col">Serviço</th>
                    <th scope="col">Status</th>
                    <th scope="col">Versão</th>
                    <th scope="col">Última Verificação</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>RadioConnect API</td>
                    <td>
                      <span class="badge badge-pill bg-success">Online</span>
                    </td>
                    <td>{{ systemStatus.version || '1.0.0' }}</td>
                    <td>{{ new Date().toLocaleString() }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { adminService } from "@/api/admin";

export default {
  page: {
    title: "Dashboard Admin",
    meta: [{ name: "description", content: "Dashboard administrativo do RadioConnect" }],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Dashboard Admin",
      items: [
        {
          text: "Administração",
          href: "/admin",
        },
        {
          text: "Dashboard",
          active: true,
        },
      ],
      stats: {},
      systemStatus: {},
      loading: false,
    };
  },
  async created() {
    await this.loadDashboardData();
  },
  methods: {
    async loadDashboardData() {
      this.loading = true;
      try {
        // Load dashboard stats
        const statsResponse = await adminService.getDashboardStats();
        this.stats = statsResponse.data;

        // Load system status
        const statusResponse = await adminService.getSystemStatus();
        this.systemStatus = statusResponse.data;
      } catch (error) {
        console.error("Erro ao carregar dados do dashboard:", error);
        this.$toast.error("Erro ao carregar dados do dashboard");
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
